export const ADD_DUPE_ENTRY_VEHICLE = 'ADD_DUPE_ENTRY_VEHICLE';
export const REMOVE_DUPE_ENTRY_VEHICLE = 'REMOVE_DUPE_ENTRY_VEHICLE';
export const CLEAR_DUPE_ENTRY_VEHICLE = 'CLEAR_DUPE_ENTRY_VEHICLE';
